<template>
  <van-popup v-model="isVisible" :style="{width:'90vw'}" class="code-pop" overlay-class="code-overlay" closeable>
    <div class="pop-content">
      <div class="code-box">
        <div class="title">克隆活动二维码</div>
        <div class="img-box">
          <qrcode-vue :value="qrUrl" :size="150"></qrcode-vue>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {QrCodeEnum} from '@/utils/constant'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    configData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    activityData() {
      return this.configData;
    },
  },
  data() {
    return {
      qrUrl: ''
    }
  },
  methods: {

  },
  created() {
    const qrUrlObj = {
      type: QrCodeEnum.clone,
      activityId: this.activityData.activityId,
      creationMode: this.activityData.creationMode || '',
      tmpType: this.activityData.tmpType || 1,
    }
    this.qrUrl = JSON.stringify(qrUrlObj);
  }
}
</script>

<style lang="stylus" scoped>
.code-pop
  border-radius 8px
  .code-box
    border-bottom 1px dotted $mainTextColor
    .title
      padding 20px 0
      font-size 16px
      font-weight bold
      text-align: center
    .img-box
      margin-bottom: 20px
      text-align: center
  .info-box
    padding 0 15px 20px
    .activity-title
      padding 15px 0 10px
      font-size 16px
      color $mainTextColor
    >>> .k-v-panel
      padding 5px 0
</style>
<style lang="stylus">
.code-overlay
  background-color: #f6f6f6
</style>